import InvestmentItem from './investment-item';

export default InvestmentItem;
